import { ApiInstance } from '..';
import {
    BillingHistoryEntry,
    BillingSettings,
    BillingSettingsUpdate,
    BillingStatus,
    BillingUrlResponse,
    Invoice,
} from './type';

export const getBillingStatus = () => {
    return ApiInstance.getInstance().get<BillingStatus>('/api/billing/status');
};

// Reconciles from Stripe first (webhook-independent), then returns live status.
export const syncBillingStatus = () => {
    return ApiInstance.getInstance().post<BillingStatus>('/api/billing/sync');
};

export const getBillingSettings = () => {
    return ApiInstance.getInstance().get<BillingSettings>(
        '/api/billing/settings'
    );
};

export const updateBillingSettings = (payload: BillingSettingsUpdate) => {
    return ApiInstance.getInstance().put<BillingSettings>(
        '/api/billing/settings',
        payload
    );
};

export const createCheckoutSession = () => {
    return ApiInstance.getInstance().post<BillingUrlResponse>(
        '/api/billing/checkout-session'
    );
};

export const createPortalSession = () => {
    return ApiInstance.getInstance().post<BillingUrlResponse>(
        '/api/billing/portal-session'
    );
};

// Billing history — invoices pulled from Stripe on demand (newest first).
export const getInvoices = () => {
    return ApiInstance.getInstance().get<Invoice[]>('/api/billing/invoices');
};

// Audit log of billing changes (price updates, slot edits, scheduled cancels).
// Platform-admin only; newest first.
export const getBillingHistory = (limit = 100) => {
    return ApiInstance.getInstance().get<BillingHistoryEntry[]>(
        `/api/billing/history?limit=${limit}`
    );
};
